<template>
    <div>
        <loadingComponent 
        @closeDialog="dialogLoading = $event" 
        v-if="dialogLoading" 
        :dialogProps="dialogLoading" 
        :loadingProps="loading" 
        :errorProps="error"
        />
        <v-dialog
            v-model="dialog"
            persistent
            max-width="500"
            >
            <v-card>
                <v-card-title class="text-h5">
                Extraction du contrat
                </v-card-title>
                <v-card-text>
                    <v-alert v-if="error==true && loading==false" type="error">
                        {{messageDialoge}}
                    </v-alert>
                    <v-alert v-if="error==false && loading==false" type="success">
                        {{messageDialoge}}
                    </v-alert>
                    <v-flex  class="text-center">
                        <v-progress-circular v-if="loading==true"
                            :size="150"
                            :width="7"
                            color="primary"
                            indeterminate
                            >
                            Patientez  ...
                        </v-progress-circular>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="loading==false"
                    color="green darken-1"
                    text
                    @click="dialog = false"
                >
                    FERMER
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
        v-model="addData"
        max-width="850"
        persistent
        >
            <v-card class="pa-4">
                <v-card-title class="text-h5">
                    Plus d'informations
                    
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-form ref="form"  lazy-validation class="justify-left">
                        <v-row  class="justify-left">
                            <v-col cols="12">
                                <span>Choix de Vente </span>
                                <v-radio-group v-model="choixVente" row>
                                    <v-radio
                                        label="Acquisition"
                                        value="acquisition"
                                    ></v-radio>
                                    <v-radio
                                        label="Renouvellement"
                                        value="renouvellement"
                                    ></v-radio>
                                </v-radio-group>
                                <v-radio-group v-model="typeVente" row>

                                    <v-radio
                                        label="Vente à distance"
                                        value="vente_distance"
                                    ></v-radio>
                                    <v-radio
                                        label="Vente sur site du client"
                                        value="vente_site_client"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>

                            <v-col cols="12">
                                <span>Mode de règlement </span>
                                <v-radio-group
                                    v-model="modePaiement"
                                    row
                                    >
                                    <v-radio
                                        label="Prélèvement"
                                        value="prelevement"
                                    ></v-radio>
                                    <v-radio
                                        label="autre"
                                        value="autre"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>
                            
                            <v-col cols="12">
                                <span>Ajouter une Adresse e-mail (si différente du Client)</span>
                                <v-radio-group
                                    v-model="addAdrsEmail"
                                    row
                                    >
                                    <v-radio
                                        label="oui"
                                        :value="true"
                                    ></v-radio>
                                    <v-radio
                                        label="non"
                                        :value="false"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12" v-if="addAdrsEmail==true">
                            
                                <v-text-field
                                    outlined
                                    v-model="adresseEmailRecus"
                                    :rules="[rules.required,rules.emailRules]"
                                    label="Adresse e-mail"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <div class="d-flex flex-column">
                                    <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                                        <p><b>N° Compteur selectionné:</b> <small>{{numCompteur}}</small></p>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                                        <v-autocomplete 
                                            v-model="selectedCompteur" 
                                            :items="listCompteurResult" 
                                            :loading="isLoading" 
                                            hide-no-data 
                                            hide-selected
                                            label="Autre compteur" 
                                            placeholder="Ajouter un compteur" 
                                            prepend-icon="mdi-account-search-outline"
                                            chips
                                            item-text="numCompteur"
                                            item-value="numCompteur"
                                            deletable-chips
                                            multiple
                                            return-object
                                            >
                                            <template v-slot:selection="{ item, index }">
                                                    <v-chip v-if="index === 0">
                                                    <span>{{ item.numCompteur }}</span>
                                                    </v-chip>
                                                    <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                    >
                                                    (+{{ selectedCompteur.length -1 }} {{selectedCompteur.length -1 > 1 ? 'éléments' : "élément"}})
                                                    </span>
                                                </template>
                                            <template v-slot:item="data">
                                                <template>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{ data.item.numCompteur }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>
                                            </template>
                                            <template v-slot:prepend-item>
                                                <v-list-item ripple @click="toggle">
                                                    <v-list-item-content>
                                                        <v-list-item-title>Select All</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-divider class="mt-2"></v-divider>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                </div>
                            </v-col>
                            
                        </v-row>
                        <v-row>
                            <v-col style="display: inline-flex; justify-content:space-between">
                                <div>
                                    <v-btn v-if="loading==false"
                                        color="error"
                                        text
                                        @click="closeModal"
                                    >
                                        Annuler
                                    </v-btn>
                                </div>
                                <div>
                                    <v-btn 
                                        v-if="loading==false"
                                        :color="$colors[2]" 
                                        class="white--text mx-2" 
                                        @click="downloadExcel">
                                        <v-icon dense class="mr-2">mdi-microsoft-excel</v-icon>
                                        Excel
                                    </v-btn>
                                    <v-btn v-if="loading==false"
                                        color="primary"
                                        @click="createContrat"
                                    >
                                        Confirmer
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-form>   
                </v-card-actions>
            </v-card>
        </v-dialog>
        

        <div>
            <v-btn
            @click="openDialog"
            icon
            depressed class="ma-auto text-capitalize">
                <v-icon  :color="$colors[0]">mdi-text-box-edit</v-icon>
            </v-btn>
        </div>
        
    </div>
</template>
<script>
import { degrees, PDFDocument, rgb, StandardFonts,layoutMultilineText } from 'pdf-lib'
import download from 'downloadjs'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import axios from 'axios'
import loadingComponent from "../../components/ui/loading-component.vue"

export default {
    name: 'TotalHorizonPlus',
    components:{loadingComponent},
    props: {
        donner: null,
        numCompteur: null,
        societe: null,
        donnerEnedis: null,
        listCompteur: [],
        donnerCompteurs: [],
    },
    data: () => ({
        addData : false,
        dialog: false,
        dialogLoading: false,
        error: false,
        loading: false,
        isLoading: false,
        messageDialoge: "",
        addAdrsEmail: false,
        choixVente: 'acquisition',
        typeVente:'vente_distance',
        modePaiement: 'prelevement',
        adresseEmailRecus: '',
        selectedCompteur: [],
        listCompteurResult: [],
        messageDialogeError: "",
        messageDialogeSucces:"",
        dialogAddCompteur: false,
        ajouterUnAutreCompteur: false,
        perPage: 3,
        currentPage: 1,
        loadingTableHistorique: false,
        fieldhistoriqueDeCotation:[
            {key:"numCompteur", label:"Numéro de compteur"},
            {key:"action",label:"Action"}
        ],
        data:{
            dateAjourdhui: new Date().getDate()+"/"+new Date().getMonth()+"/"+new Date().getFullYear(),
            dateDebut: "",
            dateFin: "",
            pdl: "",
            siret: "", 
            codeNaf: "", 
            adresseSociete: "", 
            adresseCompteur: "",
            codePostaleCompteur: '',
            voieCompteur: '',
            communeCompteur: '',
            codePostaleSociete: '',
            voieSociete: '',
            communeSociete: '',
            codePostale: '',
            nom: "",
            prenom: "", 
            email: "", 
            numTele: "", 
            consommationAnuuelle: "",
            typeCompteur: "",
            kva: "",
                
            coefBase: '',
            coefHp: '',
            coefHc: '',
            prixHC: "",
            prixHP: "",
            prixBASE: "",
            raison: '',
            nbrYears: '',
        },
        rules: {
            required: value => !!value  || 'Ce champ est obligatoire.',

            emailRules:v => !!v && /.+@.+\.+.+/.test(v) || 'E-mail invalide',
                

        }
    }),
    methods:{
        async downloadExcel() {
            try {
                this.dialog = true;
                this.loading = true;
                this.error= false;
                this.messageDialoge= "";
                const selectedDonner = this.selectedCompteur;
                selectedDonner.push({
                    ...this.donner,
                    numCompteur: this.numCompteur,
                })  
                const dataToSend = {
                    siret: this.societe.siret,
                    token: this.getToken("token"),
                    donner: selectedDonner
                };

                const response = await axios({
                    url: process.env.VUE_APP_URL_API_CLIENT + 'generate-total-multi-sites-excel/',
                    method: 'POST',
                    data: dataToSend
                });

                const fileUrl = response.data.url;
                const fileName = fileUrl.split('/').pop();
                
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', `Total_Horizon_plus_${this.societe.Raison}_${new Date().toISOString().split('T')[0]}.${fileName.split('.').pop()}`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (err) {
                console.error(err);
            } finally {
                this.dialog= false
                this.error= false
                this.loading= false
                this.messageDialoge= ""
            }
        },
        async createContrat(){
            this.$refs.form.validate();
            if(this.$refs.form.validate()){
                this.addData = false
                this.dialog= true
                this.error= false
                this.loading= true
                this.messageDialoge= ""
                var autreDonner = {}
                autreDonner.addAdrsEmail = this.addAdrsEmail
                autreDonner.choixVente = this.choixVente
                autreDonner.typeVente= this.typeVente
                autreDonner.modePaiement = this.modePaiement
                autreDonner.adresseEmailRecus = this.adresseEmailRecus
                var dataToSend = {
                    donner: this.donner,
                    donnerEnedis: this.donnerEnedis,
                    optionTarifaire: this.optionTarifaire,
                    numCompteur: this.numCompteur,
                    societe: this.societe,
                    autreDonner: autreDonner,
                    listCompteur: this.selectedCompteur,
                }
                await axios({
                    url: process.env.VUE_APP_URL_EDITION_CONTRACT + '/totalHorizonContratPlus',
                    // url: 'http://127.0.0.1:3000/totalHorizonContratPlus',
                    method: 'POST',
                    data: dataToSend,
                    headers:{'content-type': 'application/json'}
                    
                })
                .then(async (res) => {
                    var doc = await PDFDocument.load(res.data)
                    doc = await doc.save()
                    download(doc, 'Total_Horizon_plus_'+this.societe.Raison+'_.pdf', 'application/pdf')
                }).catch((err)=>{
                    console.log(err)
                })
                this.dialog= false
                this.error= false
                this.loading= false
                this.messageDialoge= ""
            }
        },
        toggle(){
            this.selectedCompteur = [...this.listCompteurResult]
        },
        async openDialog() {
            this.prepareCompteurs();
            this.resetModal();
            this.addData = true
        },
        closeModal(){
            this.addData = false;
            this.resetModal();
        },
        prepareCompteurs() {
            // Filter and map the compteurs, excluding the current one
            this.listCompteurResult = this.donnerCompteurs
                .filter(cpt => {
                    // Keep compteur if it's in listCompteur AND it's not the current compteur
                    return this.listCompteur.includes(cpt.NumCompteur) && 
                        cpt.NumCompteur !== this.numCompteur;
                })
                .map(cpt => {
                    const gazOffer = cpt.resultat.result.find(offer => 
                        (offer.fournisseur == 'total energie' || offer.fournisseur == 'TDE') && offer.type == 'Horizon +'
                    );
                    if (gazOffer) {
                        // Return the mapped compteur data
                        return {
                            ...gazOffer,
                            numCompteur: cpt.NumCompteur,
                        };
                    }
                    return null; // Explicitly return null if no gazOffer is found
                })
                .filter(item => item !== null); // Remove null values
            
        },
        resetModal() {
            this.choixVente = 'acquisition';
            this.typeVente = 'vente_distance'
            this.modePaiement = 'prelevement';
            this.adresseEmailRecus = '';
            this.selectedCompteur = []
        }
    }
}
</script>
<style scoped>
::v-deep .v-input--selection-controls__input + .v-label{
   margin-bottom:0px !important;
}
</style>